module.exports = __webpack_public_path__ + "images/emoji/bus.d563d5a86cf72195a5d2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bus.png
// module id = tQKL
// module chunks = 14